export default __webpack_public_path__ + "static/media/alien_NL.79b600f2.mp3";